module.exports = __webpack_public_path__ + "static/img/broadcast.c8c3244b.png";